import { SearchResultItem, SearchableEntityType } from '../globalSearch.types';
import { ENTITY_CONFIG } from './entityConfig';
import { EntityConfig } from './entityConfig.types';

interface ResolveRouteOptions {
  isStore: boolean;
}

export const resolveRoute = (item: SearchResultItem, options?: ResolveRouteOptions): string => {
  const isStore = Boolean(options?.isStore);
  const config = ENTITY_CONFIG[item.entityType] as EntityConfig;
  return config.detail(item, isStore);
};

const LIST_SEARCH_PARAM = 'query';

interface ResolveEntityListRouteParams {
  entityType: SearchableEntityType;
  term: string;
  isStore: boolean;
}

export const resolveEntityListRoute = ({
  entityType,
  term,
  isStore,
}: ResolveEntityListRouteParams): string => {
  const path = ENTITY_CONFIG[entityType].list(isStore);
  const trimmedTerm = term.trim();
  return trimmedTerm ? `${path}?${LIST_SEARCH_PARAM}=${encodeURIComponent(trimmedTerm)}` : path;
};
